export const LOCAL_STORAGE_KEYS = {
  WEBSITE_USER: 'WebsiteUser',
};

export const SESSION_STORAGE_KEYS = {
  COOKIE_ALERT: 'CookieAlert',
  FORGOT_PASSWORD_USER_ID: 'ForgotPassword:UserId',
};
